import Analysis from './Analysis';

const RivalAnalysis = () => (
  <Analysis
    accountType="rival"
    emptyAccountDescription="暂无竞品账号数据"
    showSummary={false}
    title="竞品看板"
  />
);

export default RivalAnalysis;
